import React from 'react';
import Header from "../../../commons/Header/Header";
import Footer from "../../../commons/Footer/Footer";
import PartnerForm from "../../../commons/PartnerForm/PartnerForm";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Banner from "../../../../assets/images/travelance-banner-online-training.webp"
// new Page Added
const PartnerEfgPageFr = (props) => {

  return (
    <>
      <Header en='/partner/experiorfinancialgroup' fr='/partenaires/experiorfinancialgroup' lang='fr' />
      <Container className="mainDiv partnerFormPage">
        <Row className="">
          <Col xl={12} className="content">
            <h1>Experior Financial Group Information Centre</h1>
            <Container>
              <Row className="">
                <Col xl={12}>
                     <img src={Banner} width="100%" alt="experior-training" target="_blank" />
                     <br />
                     <h2><strong>Bienvenue au Centre d’information sur les voyages pour les courtiers d’Experior Financial Group</strong></h2>
                     <p>Sur cette page, vous trouverez les outils pour vous aider à commencer à vendre des produits Travelance.</p>
                </Col>
                <Col xl={8} className="">
                  <PartnerForm heading="Remplissez ce formulaire pour commencer le processus d’inscription avec Travelance." mga="efg" lang="fr" typage="/partenaires/formulaire/merci"/>
                  <br />
                  <h2>Formation en ligne</h2>
                  <p><a href="/partenaires/sessions-de-formation-en-ligne" target="_blank" rel="noopener noreferrer">Session de formation en ligne</a> - Inscrivez-vous à nos sessions de formation en ligne pour découvrir nos produits et services. Chaque semaine, les membres de notre équipe animent des sessions interactives, animées et riches en informations, avec des classes de petite taille, et un membre de l’équipe peut répondre à toutes vos questions.</p>
                  <p><a href="https://academy.travelance.ca/remote-login/login.cfm"  rel="noopener noreferrer">Travelance Academy</a> - Notre option de formation la plus flexible. Une fois que vous avez terminé le processus de partenariat avec Travelance, vous pourrez accéder à Travelance Academy via MyTL. Accédez à l’apprentissage en ligne sur demande, que vous pouvez compléter selon votre propre emploi du temps.</p>
                  <p>Vous cherchez une formation pour votre équipe? Envoyez un courriel à <a href="mailto:training@travelance.ca">training@travelance.ca</a> pour demander une session.</p>
                  <h2>Ressources pour les partenaires de voyage</h2>
                  <p>Pour vous aider à commencer à vendre des produits Travelance, nous avons créé des ressources pour vous aider à chaque étape du processus. Accédez à des formulations complètes de politiques, des graphiques de taux, des étapes pour vendre des guides, des liens vers des ressources utiles, et plus encore ! <a href="/partner/resources/" target="_blank" rel="noopener noreferrer">Cliquez ici pour accéder à notre page Web de ressources partenaires.</a>.</p>
                  <h2>Informations de contact</h2>
                  <p>Pour les questions liées aux politiques, aux changements ou à l’assistance du portail, communiquez avec les services de soutien, du lundi au vendredi, de 9 h à 19 h (HE), <a href="mailto:info@travelance.ca">info@travelance.ca</a> ou <a href="tel:8555668555">1-855-566-8555</a> poste 1.</p>
                  <h2>Pour les demandes de contrats</h2>
                  <ul className="list">
                    <li>West Contracting - <a href="mailto:westcontracting@experiorheadoffice.ca">westcontracting@experiorheadoffice.ca</a></li>
                    <li>East Contracting - <a href="mailto:eastcontracting@experiorheadoffice.ca">eastcontracting@experiorheadoffice.ca</a></li>
                  </ul>
                </Col>
                <Col xl={4} className="">
                  <div className="stickyDiv">
                    <div className="holder_block">
                      <h2>Liens rapides</h2>
                      <ul className="list">
                        <li><a href="/reclamations/" target="_blank" rel="noopener noreferrer">Réclamations</a></li>
                        <li><a href="https://www.getreliable.com/getreliable/" target="_blank" rel="noopener noreferrer">Connexion au portail en ligne</a></li>
                        <li><a href="/au-sujet-de-notre-assureur/" target="_blank" rel="noopener noreferrer">Au sujet de notre assureur</a></li>
                        <li><a href="/fr#faqSection" target="_blank" rel="noopener noreferrer">Partenaires FAQs</a></li>
                        <li><a href="/partenaires/sessions-de-formation-en-ligne" target="_blank" rel="noopener noreferrer">Sessions de formation en ligne</a></li>
                        <li><a href="https://www.travel.gc.ca/travelling/advisories/" target="_blank" rel="noopener noreferrer">Conseils aux voyageurs</a></li>
                      </ul>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
      <Footer lang="fr" />
    </>
  );
}

export default PartnerEfgPageFr;
